import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {Title} from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'notd-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})

export class FaqComponent implements OnInit {
  public isCollapsedSearch: boolean;
  public isCollapsed: boolean;

  public isLoggedIn = false;
  public user: any = {};

  constructor(@Inject(PLATFORM_ID) protected platformId: object,
  private titleService: Title) {

  }

  ngOnInit() {
    this.titleService.setTitle('FAQ - notd.io');
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
  }

  signup() {
    console.log('signup');
  }
}
